import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addEnterprise from "./components/addEnterprise";
import appInfo from "./components/appInfo.vue";
export default {
  name: "enterpriseManagement",
  mixins: [loadMoreList, commonData],
  components: {
    addEnterprise: addEnterprise,
    appInfo: appInfo
  },
  data: function data() {
    return {
      pagingReqFn: "enterpriseList",
      delIds: [],
      loginData: ''
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    audit: function audit(row) {
      var _this = this;

      var status = "";

      if (row.status == 0) {
        status = 1;
      } else if (row.status == 1) {
        status = 2;
      } else if (row.status == 2) {
        status = 1;
      }

      this.$api.enterpriseAudit({
        id: row.id,
        status: status
      }).then(function (res) {
        if (res.status == 200) {
          _this.$message.success('操作成功');

          _this.getList(_this.paramsData.page);
        }
      });
    },
    goToUsers: function goToUsers(row) {
      this.$router.push({
        name: 'users',
        params: {
          enterprise_id: row.id
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'enterpriseDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this2.getList(_this2.paramsData.page);
      });
    }
  }
};